import './style.css';
import { boot } from './app.js';

boot().catch((err) => {
  console.error(err);
  const sub = document.querySelector('.loader-sub');
  if (sub) {
    sub.textContent = err?.message || 'could not start the studio';
    sub.style.maxWidth = '36rem';
    sub.style.margin = '0 auto';
    sub.style.whiteSpace = 'pre-wrap';
    sub.style.letterSpacing = '0';
    sub.style.textTransform = 'none';
  }
});
